<div class="cmt-register calculation-model-edit-component" [class.close]="shouldClose">
  <div class="cmt-register-container" *ngIf="newestTemplateMappingVersion">
    <steps-manager [stepsCount]="stepsCount" [currentStep]="currentStep" (onCloseClicked)="onCloseClicked()" [displayCloseButton]="true"></steps-manager>

    <!-- STEP 1 -->
    <section class="upload-section uploaded-files-section" [hidden]="currentStep !== 1" *ngIf="uploadedFiles.length">
      <h2>{{ 'import.importFile' | translate }}</h2>
      <kendo-grid [data]="uploadedFiles" [selectable]="{enabled: false, checkboxOnly: true}" [scrollable]="'scrollable'" [hidden]="uploadRequested">
        <kendo-grid-column [field]="'originalFilename'" [title]="'Name'" [width]="500"></kendo-grid-column>
        <kendo-grid-column [field]="'groupDescription'" [title]="'Group'" [width]="150"></kendo-grid-column>
        <kendo-grid-column [field]="'mappingVersionDescription'" [title]="'Mapping'" [width]="150"></kendo-grid-column>
        <kendo-grid-command-column [width]="400">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <button kendoButton *ngIf="dataItem.canUpgrade" (click)="upgradeMappingVersion(dataItem)">{{'calculationModel.upgradeMappingVersion' | translate}}</button>
            <button kendoButton (click)="downloadFileItem(dataItem)" style="width: 70px">{{'import.download' | translate}}</button>
            <button kendoButton (click)="uploadEditTemplate(dataItem)" style="width: 70px">{{'calculationModel.upload' | translate}}</button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>

      <div [hidden]="!uploadRequested" class="inline-upload">
        <h2>{{ 'calculationModel.importFileInline' | translate }}</h2>
        <kendo-upload #kendoUpload [autoUpload]="false" actionsLayout="start" [restrictions]="uploadRestrictions"
                      (select)="onFileSelect(kendoUpload, $event)"
                      [batch]="false"
                      [multiple]="false">
          <ng-template kendoUploadFileTemplate let-files let-state="state">
            <label class="import-file-name-label">{{ files[0].name }}</label>
            <button kendoButton (click)="onRemoveFile(kendoUpload, files[0].uid)" class="calculation-model-remove-button">
              {{'import.remove' | translate}}
            </button>
          </ng-template>
        </kendo-upload>
      </div>
    </section>

    <!-- STEP 2 -->
    <section class="template-edit-section" [hidden]="currentStep !== 2" style="padding-top: 58px;">

      <kendo-grid #templateEditGrid [data]="gridData" [selectable]="{enabled: false, checkboxOnly: true}" [height]="150">
        <kendo-grid-column [field]="'name'" [title]="'calculationModel.name' | translate" [width]="500">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-textbox [(ngModel)]="dataItem.name"
                           name="Name">
            </kendo-textbox>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'countryId'" [title]="'calculationModel.country' | translate" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.countryId" [data]="countryRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'sectorId'" [title]="'calculationModel.sector' | translate" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.sectorId" [data]="sectorRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'valuationMethodId'" [title]="'calculationModel.valuationMethod' | translate" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.valuationMethodId" [data]="valuationMethodRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="'statusId'" [title]="'calculationModel.status' | translate" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          </ng-template>
          <ng-template kendoGridEditTemplate let-dataItem="dataItem">
            <kendo-dropdownlist [(ngModel)]="dataItem.statusId" [data]="statusRefList" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>

    </section>

    <div class="buttons-container">
      <button kendoButton class="prev" *ngIf="currentStep > 1" (click)="prevStep()">{{'calculationModel.back' | translate}}</button>
      <button kendoButton class="next" *ngIf="isNextEnabled() && currentStep < stepsCount" (click)="nextStep()">{{'calculationModel.next' | translate}}</button>
      <button kendoButton class="next" *ngIf="currentStep === 2" (click)="saveTemplate()">{{'calculationModel.save' | translate}}</button>

      <button kendoButton class="prev" *ngIf="uploadRequested" (click)="uploadCanceled()">{{'calculationModel.cancel' | translate}}</button>
      <button kendoButton class="next" *ngIf="uploadRequested && importFiles.length" (click)="uploadConfirmed()">{{'calculationModel.upload' | translate}}</button>
    </div>
  </div>
</div>

<ng-template #importPreviewGrid let-import='import'>
  <div class="import-grid-container" *ngIf="import.value && import.value.DataRoot && import.value.DataRoot.Data && import.value.DataRoot.Data.length">
    <kendo-grid [data]="import.value.DataRoot.Data" [scrollable]="'scrollable'">
      <kendo-grid-column *ngFor="let column of import.value.DataRoot.Data[0] | keyvalue | sortImportFields" [field]="column.key"
                         [title]="iprs.getPreviewColumnTitle(import.key, column.key)"
                         [width]="iprs.getPreviewColumnWidth(import.key, column.key)"
                         [hidden]="!iprs.shouldShowField(import.key, column.key)"
                         [format]="iprs.getFormat(import.key, column.key)">
      </kendo-grid-column>
    </kendo-grid>
  </div>
</ng-template>
